import {Person} from "../../../services/interface/query/person";
import ChecklistOfac from "./ChecklistOfac";
import ChecklistCriminalRecord from "./ChecklistCriminalRecord";
import ChecklistHomonyms from "./ChecklistHomonyms";
import ChecklistProvidences from "./ChecklistProvidences";
import ChecklistPeps from "./ChecklistPeps";

interface Props {
    person?: Person;
}
export default function Checklists({person}: Props): JSX.Element {
    return (
        <div className={'custom-card py-5 px-3 flex flex-col gap-3'}>
            <ChecklistOfac {...{person}}/>
            <ChecklistCriminalRecord {...{person}}/>
            <ChecklistHomonyms {...{person}}/>
            <ChecklistProvidences {...{person}}/>
            <ChecklistPeps {...{person}}/>
        </div>
    )
}
